import React from 'react';
import { FadeIn } from './FadeIn';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito máquinas caras?',
    a: 'No, solo un bowl, una balanza de $10 y tu horno.'
  }, {
    q: '¿Es difícil conseguir los ingredientes?',
    a: 'No, te doy la lista exacta para Walmart y Publix.'
  }, {
    q: '¿Cuánto tiempo me quitará?',
    a: 'Menos de 15 minutos de trabajo activo.'
  }];
  return <section className="bg-bakery-cream py-24 px-6" data-id="element-25">
      <div className="max-w-3xl mx-auto" data-id="element-26">
        <FadeIn className="text-center mb-16" data-id="element-27">
          <h2 className="text-4xl font-serif font-bold text-bakery-brown mb-4" data-id="element-28">
            Preguntas Frecuentes
          </h2>
          <div className="w-16 h-1 bg-bakery-amber mx-auto rounded-full" data-id="element-29"></div>
        </FadeIn>

        <div className="space-y-8" data-id="element-30">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-31">
              <div className="border-b border-bakery-tan pb-8" data-id="element-32">
                <h3 className="text-2xl font-serif font-bold text-bakery-brown mb-3" data-id="element-33">
                  {faq.q}
                </h3>
                <p className="text-lg text-bakery-brown/70" data-id="element-34">{faq.a}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}